<template>
    <div :class="isMobileOrTablet ? 'crypto-book-nav-mobile' : 'crypto-book-nav'"
         class="align-items-center">
        <a v-if="prevSection"
           :href="`${route('crypto-book')}/${prevSection.slug}`"
           class="mx-2">
            <div class="d-flex align-items-center">
                <div class="px-2">
                    <i class="fa-solid fa-caret-left" />
                </div>
                <div v-if="!isMobileOrTablet"
                     class="pr-2 crypto-navigation-item">
                    <translate translation-key="crypto-book.prevSection"
                               fallback="Prev Section" />
                </div>
                <div v-else
                     class="pr-2">
                    <translate translation-key="crypto-book.prev"
                               fallback="Prev" />
                </div>
            </div>
        </a>
        <span v-if="prevSection"
              class="index" />
        <a v-if="isCustomDesktop"
           :href="route('crypto-book')"
           class="mx-2">
            <div class="d-flex align-items-center">
                <div class="px-2"><i class="fa-solid fa-house" /></div>
                <div v-if="!isMobileOrTablet"
                     class="pr-2 crypto-navigation-item">
                    <translate translation-key="crypto-book.handbookCoverPage"
                               fallback="Handbook Cover Page" />
                </div>
                <div v-else
                     class="pr-2">
                    <translate translation-key="crypto-book.handbook"
                               fallback="Handbook" />
                </div>
            </div>
        </a>
        <div v-else
             class="mx-2"
             @click="toggleMobileSidebar">
            <div class="d-flex align-items-center">
                <div class="px-2">
                    <i class="fa-solid fa-house" />
                </div>
                <div v-if="!isMobileOrTablet"
                     class="pr-2 crypto-navigation-item">
                    <translate translation-key="crypto-book.handbookCoverPage"
                               fallback="Handbook Cover Page" />
                </div>
                <div v-else
                     class="pr-2"
                     role="button">
                    <translate translation-key="crypto-book.handbook"
                               fallback="Handbook" />
                </div>
            </div>
        </div>
        <span v-if="nextSection"
              class="index" />
        <a v-if="nextSection"
           :href="`${route('crypto-book')}/${nextSection.slug}`"
           class="mx-2">
            <div class="d-flex align-items-center">
                <div v-if="!isMobileOrTablet"
                     class="pl-2 crypto-navigation-item">
                    <translate translation-key="crypto-book.nextSection"
                               fallback="Next Section" />
                </div>
                <div v-else
                     class="pl-2">
                    <translate translation-key="crypto-book.next"
                               fallback="Next" />
                </div>
                <div class="px-2">
                    <i class="fa-solid fa-caret-right" />
                </div>
            </div>
        </a>
        <span v-if="!nextSection"
              class="index" />
        <a v-if="!nextSection"
           :href="route('crypto-book-glossary')"
           class="mx-2">
            <div class="d-flex align-items-center">
                <div v-if="!isMobileOrTablet"
                     class="pl-2">
                    <translate translation-key="crypto-book.nextSection"
                               fallback="Next Section" />
                </div>
                <div v-else
                     class="pl-2">
                    <translate translation-key="crypto-book.next"
                               fallback="Next" />
                </div>
                <div class="px-2"><i class="fa-solid fa-caret-right" /></div>
            </div>
        </a>
    </div>
</template>

<script>
    import { route } from '@/js/helpers/helpers';
    import { useDeviceSize } from '@/js/composables/useDeviceSize';
    import { useCustomDeviceSize } from '@/js/composables/useCustomDeviceSize';

    export default {
        name: 'SectionNavbar',
        props: {
            nextSection: {
                type: Object,
                default() {
                    return {};
                },
            },
            prevSection: {
                type: Object,
                default() {
                    return {};
                },
            },
        },
        setup() {
            const { isMobileOrTablet } = useDeviceSize();
            const { isCustomDesktop } = useCustomDeviceSize();

            return {
                isMobileOrTablet,
                isCustomDesktop,
            };
        },
        methods: {
            toggleMobileSidebar() {
                this.$emit('mobileSidebarToggle');
            },
            route,
        },
    };
</script>
